import { BulkSpreadsheet, type BulkColumn } from '../shared/BulkSpreadsheet';
import { attributeService } from '@kss/api';
import type { AttributeCreate } from '@kss/api';

const columns: BulkColumn<AttributeCreate>[] = [
  { key: 'name', header: 'Name', required: true, sample: 'Colour' },
  { key: 'description', header: 'Description', sample: 'Visible colour of the item' },
];

export default function BulkAttribute() {
  return (
    <BulkSpreadsheet<AttributeCreate> title="Bulk import attributes" entityLabel="attribute" backPath="/panel/attributes" columns={columns} module="Attribute"
      onImport={async (rows) => {
        const created = await attributeService.create(rows);
        return { created: Array.isArray(created) ? created.length : rows.length };
      }}
    />
  );
}
